import Flex from '@deprecated-ui/common/Flex';
import Text from '@deprecated-ui/common/Text';
import color from '@deprecated-ui/_style/color';
import CorpActionTag from 'global/CorpAction/CorpActionTag';
import If from 'global/ErrorHandlers/If';
import Notation from 'global/Notation';
import { BadgeLabelWrapper } from 'global/Notation/styled';
import PopoverNotation from 'global/Notation/PopoverNotation';
import { CompanyInfo } from '../../../../@types/company';

interface ITradingCompanyTags {
  company: CompanyInfo;
}

const TradingCompanyTags = ({ company }: ITradingCompanyTags) => {
  const { symbol, name, uma, corp_action, indexes, notation, market_hour } =
    company;

  const isXNotationEnabled = market_hour.suspend_info;

  const isDBX = indexes.indexOf('DBX') > -1;
  const isSyariah = indexes.indexOf('JII') > -1 || indexes.indexOf('ISSI') > -1;

  const hasNotation = notation.length > 0;
  const hasXNotation = notation.find((value) => value.notation_code === 'X');
  const onlyHasXNotation =
    notation.length === 1 && notation[0].notation_code === 'X';

  const checkIndicator = hasNotation && !onlyHasXNotation;
  const showIndicator = isXNotationEnabled ? checkIndicator : hasNotation;
  const showXIcon = isXNotationEnabled && hasXNotation;

  return (
    <Flex align="center">
      {/* Indicator(!) Notation */}
      <If condition={showIndicator}>
        <Notation
          symbol={symbol}
          name={name}
          notation={notation}
          uma={uma}
          type="indicator"
          placement="bottom"
          isNotationBadges
        />
      </If>

      {/* X Notation */}
      <If condition={showXIcon}>
        <Notation
          symbol={symbol}
          name={name}
          notation={notation}
          uma={uma}
          type="x"
          placement="bottom"
          isNotationBadges
        />
      </If>

      {/* Corp Action Tag */}
      <If condition={corp_action.active}>
        <CorpActionTag corpAction={corp_action} isCorpActionBadges />
      </If>

      {/* UMA Notation */}
      <If condition={uma}>
        <Notation
          symbol={symbol}
          name={name}
          notation={notation}
          uma={uma}
          type="uma"
          placement="bottom"
          isNotationBadges
          isPopover={false}
        />
      </If>

      <PopoverNotation company={company} />

      {/* DBX Badge */}
      <If condition={isDBX}>
        <BadgeLabelWrapper>
          <Text size="12px" color={color.primary}>
            DBX
          </Text>
        </BadgeLabelWrapper>
      </If>

      {/* Syariah Badge */}
      <If condition={isSyariah}>
        <BadgeLabelWrapper>
          <Text size="12px" color={color.primary}>
            Syariah
          </Text>
        </BadgeLabelWrapper>
      </If>
    </Flex>
  );
};

export default TradingCompanyTags;
